// GroupedAllocationTable.js
import React from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { getGroupFunds, formatValues } from './ChartDataTransformer';
//import DOMPurify from 'dompurify';
//import './FundAllocationTable.css';

const GroupedAllocationTable = ({ fundData = {}, inputValue, GroupedAllocationTableLabels = {}, isTableExpandedByDefault = false, language = 'en'}) => {
    const { t } = useTranslation();
    const data = (fundData && fundData.FundDataValues && Array.isArray(fundData.FundDataValues)) ? fundData.FundDataValues : [];
    const groupedFunds = getGroupFunds(data);
    const expandedClass = isTableExpandedByDefault ? "is-active" : "";
    const dataIndex = get(inputValue, 'dataIndex');
    const isReverseIndex = get(inputValue, 'isReverseIndex', true);
    const formatConfig = {
        format: [
            language,
            {
                style: 'unit',
                unit: 'percent'
            }
        ],
        decimalLimit: 2
    };

    const getReverseIndexValue = (arr, index, isReverseIndex) => {
        const currentIndex = isReverseIndex ? arr.length - index : index - 1;
        const value = arr[currentIndex]
        return formatValues(value, formatConfig);
    };

    if (!data || data.length === 0) {
        return <div>Loading...</div>;
    }

    return (
        <div className="js-individual-funds-accordion funds-portfolio-table-container u-margin-top-m">
            <div className="funds-portfolio-table-head">
                <div className="funds-portfolio-label">
                    <div>{GroupedAllocationTableLabels.tableColumnFundNameLabelOverride || t('tableColumnFundNameLabel')}</div>
                    <div>{GroupedAllocationTableLabels.tableColumnShareCaptionOverride || t('tableColumnShareCaption')}</div>
                </div>
            </div>
            <div className={`funds-portfolio-table ${expandedClass}`}>
                <ul>
                    {groupedFunds.map((groupValue, groupIndex) => (
                        <li key={groupIndex} className="funds-portfolio-parent-list">
                            <div tabIndex="0" className="funds-portfolio-label funds-portfolio-heading">
                                <div>{groupValue.groupBy}</div>
                                <div>
                                    <span className="lifecycle-toggle-icon"></span>
                                </div>
                            </div>
                            <ul className="funds-portfolio-sub-heading">
                                {groupValue.funds.map((fundValue, fundIndex) => (
                                    <li key={fundIndex} tabIndex="0" data-name={fundValue.name}>
                                        <div className="funds-portfolio-label">
                                            <div>
                                                {!fundValue.SeoName && (
                                                    <>
                                                        <span>{fundValue.name}</span> <i data-toggle="modal" data-infotext={GroupedAllocationTableLabels.infoText} data-trigger="allocation-funds-popup" className="c-icon c-info-icon c-icon--info-circle-o"></i>
                                                    </>
                                                )}
                                                {fundValue.SeoName && (
                                                    <a className="c-link c-link--block c-link--capitalize" href={`${GroupedAllocationTableLabels.detailLinkBaseUrl}${fundValue.SeoName}`} aria-label={fundValue.name}><span className="c-link__text">{fundValue.name}</span></a>
                                                )}
                                            </div>
                                            <div>
                                                <span className="menu-percent">{getReverseIndexValue(fundValue?.data, Number(dataIndex), isReverseIndex)}</span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
            <div id="allocation-funds-popup" className="c-popup js-popup " tabIndex="-1" role="dialog">
                <div className="c-popup__dialog c-popup__dialog--disclaimer" role="document">
                    <div className="c-popup__header">
                        <span className="c-popup__close c-icon c-icon--close" data-dismiss="modal" aria-label={t('closeAriaLabel')}></span>
                    </div>
                    <div className="c-popup__body">
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GroupedAllocationTable;